import { NgZone } from '@angular/core';
import { Router } from '@angular/router';

import { FeatureFlagsService } from './shared/services';
import { AuthService } from './shared/ui/services/auth/auth.service';

export function initializeAppFactory(
  authService: AuthService,
  featureFlagsService: FeatureFlagsService,
  router: Router,
  ngZone: NgZone
): () => Promise<boolean> {
  return () =>
    new Promise<boolean>(resolve => {
      authService.onAuthStateChanged(user => {
        ngZone.run(() => {
          user
            ? authService
                .getIdTokenResult()
                .then(tokenResult =>
                  featureFlagsService.init(user, tokenResult)
                )
                .then(() => router.initialNavigation())
            : router.initialNavigation();
        });
      });

      resolve(true);
    });
}
